import React, { useEffect,useState } from "react";
import {
  Card,
  Form,
  Typography,
  Flex,
  Divider,
  Row,
  Col,
  Drawer,
  Input,
  Upload,
  Modal,
  message,
} from "antd";
import { TbPencil } from "react-icons/tb";
import { uploadButton } from "../../../../components/button/index.js";

const getBase64 = (file) =>
  new Promise((resolve, reject) => {
    const reader = new FileReader();
    reader.readAsDataURL(file);
    reader.onload = () => resolve(reader.result);
    reader.onerror = (error) => reject(error);
  });

const dividerProp = {
  orientation: "left",
  style: { marginBlock: 10 },
  className: "!border-black",
};
export default function MyFormManage({
  form,
  show,
  close,
  title = "จัดการข้อมูล",
  img,
}) {
  const [openDrawer, setOpenDrawer] = React.useState(show);
  const [fileList, setFileList] = useState([]);
  const [previewOpen, setPreviewOpen] = useState(false);
  const [previewImage, setPreviewImage] = useState("");

  useEffect(() => {
    setOpenDrawer(show);
  }, [show]);

  useEffect(() => {
    if (!show) return;

    const fromApi = Array.isArray(img) ? img : [];
    if (fromApi.length > 0) {
      setFileList(fromApi);
      form?.setFieldValue?.("img_img", fromApi);
    } else {
      setFileList([]);
      form?.setFieldValue?.("img_img", []);
    }
  }, [img, show, form]);

  const handlePreview = async (file) => {
    if (!file.url && !file.preview) {
      file.preview = await getBase64(file.originFileObj);
    }
    setPreviewImage(file.url || file.preview);
    setPreviewOpen(true);
  };

  const handleChange = ({ file, fileList: newFileList }) => {
    /* ตอนกดลบรูป antd จะยิง onChange มาด้วย โดย file.status = "removed"
       และรูปที่โหลดมาจาก DB บางรายการไม่มี name → ถ้าไปเช็คนามสกุลต่อจะ error
       ทำให้ค่าใน list ไม่ถูกอัปเดต กลายเป็นลบรูปไม่ออก */
    if (file?.status === "removed" || !file?.name) {
      const next = Array.isArray(newFileList) ? newFileList.slice(-1) : [];
      setFileList(next);
      form?.setFieldValue?.("img_img", next);
      return;
    }

    const allowedExtensions = [".jpg", ".jpeg", ".png", ".gif"]; // รายการสกุลไฟล์ที่อนุญาต
    const fileExtension = file.name.slice(
      ((file.name.lastIndexOf(".") - 1) >>> 0) + 2,
    ); // สกุลไฟล์ของไฟล์ที่อัพโหลด
    if (!allowedExtensions.includes(`.${fileExtension.toLowerCase()}`)) {
      message.error("สกุลไฟล์ไม่ถูกต้อง");
      // onError();
      return false;
    } else {
      // const newFile = {
      //       uid: file.uid,
      //       name: file.name,
      //       status: "done",
      //       url:
      //         `${BACKEND_URL_MAIN}/uploads/ERP/Items/` +
      //         form.getFieldValue("pg_code") +
      //         "/" +
      //         "Item_Pic" +
      //         "_" +
      //         file.name,
      //       // url: `${BACKEND_URL_MAIN}/uploads/ERP/Items/`+ form.getFieldValue("pg_code") + '/' + file.uid + "_" + file.name,
      //     };
      // keep latest one only
      const next = Array.isArray(newFileList) ? newFileList.slice(-1) : [];
      setFileList(next);
      form?.setFieldValue?.("img_img", next);

    }
  };

  const handleCancel = () => setPreviewOpen(false);

  const headStyle = {
    borderBottom: `2px solid var(--secondary)`,
    backgroundColor: "#d3d3d3",
  };

  const ThisTitle = (
    <>
      <Flex align="center" gap={4}>
        <TbPencil style={{ fontSize: "1rem" }} />
        <Typography.Text className="ms-1 mb-0">{title}</Typography.Text>
      </Flex>
    </>
  );

  const information = (
    <div className="ink-manage">
      <Divider {...dividerProp}>ข้อมูล</Divider>
      <Card style={{ backgroundColor: "#f0f0f0" }}>
        <Row
          gutter={[{ xs: 32, sm: 32, md: 32, lg: 12, xl: 12 }, 8]}
          className="m-0"
        >
          <Col xs={24} sm={24} lg={24}>
            <Form.Item
              label="ชื่อรูปแบบอิงค์"
              name="ink_name"
              rules={[
                { required: true, message: "กรุณากรอกข้อมูลให้ครบถ้วน!" },
              ]}
            >
              <Input placeholder="กรอกชื่อรูปแบบอิงค์" />
            </Form.Item>
          </Col>
          <Col xs={24} sm={24} lg={24}>
            <Form.Item
              label="บรรทัดที่ 1"
              name="ink_description_1"
              rules={[
                { required: true, message: "กรุณากรอกข้อมูลให้ครบถ้วน!" },
              ]}
            >
              <Input />
            </Form.Item>
          </Col>
          <Col xs={24} sm={24} lg={24}>
            <Form.Item label="บรรทัดที่ 2" name="ink_description_2">
              <Input />
            </Form.Item>
          </Col>
          <Col xs={24} sm={24} lg={24}>
            <Form.Item label="บรรทัดที่ 3" name="ink_description_3">
              <Input />
            </Form.Item>
          </Col>
          <Col xs={24} sm={12} lg={12}>
            <Form.Item label="ตำแหน่งพิมพ์" name="ink_position">
              <Input placeholder="เช่น ข้างขวด / ใต้ฝา" />
            </Form.Item>
          </Col>
          <Col xs={24} sm={12} lg={12}>
            <Form.Item label="สีหมึก" name="ink_color">
              <Input placeholder="เช่น ขาว / ดำ" />
            </Form.Item>
          </Col>
          <Col xs={24} sm={24} lg={24}>
            <Form.Item label="หมายเหตุ" name="ink_remark">
              <Input placeholder="หมายเหตุเพิ่มเติม" />
            </Form.Item>
          </Col>
          <Col xs={24} sm={24} lg={24}>
            รูป
            <Form.Item
              name="img_img"
              valuePropName="fileList"
              getValueFromEvent={(event) => event?.fileList}
              // rules={[
              //   {
              //     required: true,
              //     message: "กรุณาอัพโหลดรูปสินค้า!",
              //   },
              // ]}
            >
              <Upload
                fileList={fileList}
                listType="picture-card"
                accept="image/*"
                maxCount={1}
                beforeUpload={() => false}
                onChange={handleChange}
                onPreview={handlePreview}
                onRemove={() => {
                  setFileList([]);
                  form?.setFieldValue?.("img_img", []);
                  return true;
                }}
              >
                {fileList.length >= 1 ? null : uploadButton}
              </Upload>
            </Form.Item>
          </Col>
        </Row>
      </Card>
    </div>
  );

  return (
    <>
      <Drawer
        title={ThisTitle}
        onClose={() => {
          setOpenDrawer(false);
        }}
        open={openDrawer}
        width="100%"
        className="responsive-drawer"
        afterOpenChange={(e) => {
          !e && close(false);
        }}
        getContainer={false}
        styles={{ header: headStyle }}
      >
        <Form form={form} layout="vertical" autoComplete="off">
          {information}
        </Form>
      </Drawer>

      <Modal
        open={previewOpen}
        title="previewTitle"
        footer={null}
        onCancel={handleCancel}
        width={1200}
      >
        <img
          alt="example"
          style={{
            width: "100%",
          }}
          src={previewImage}
        />
      </Modal>
    </>
  );
}
